"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHeaderSection = void 0;
exports.defaultHeaderSection = {
    translate: {
        title: 'Property News & Insights',
        // tslint:disable-next-line: max-line-length
        paragraph: 'This section aims to provide an overview of the latest news & trends exhibited across Hong Kong and Global property markets. With expert commentary and opinion, we keep you up to date on property happenings both near and far.',
    },
};
